export default "__VITE_ASSET__068af13f__"